<div class="flex-fill d-flex flex-column">
    <div class="m-1 grid-fill" *ngIf="orderLineDetails">
        <dx-data-grid
            #dataGrid
            [dataSource]="orderLineDetails"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="created" width="100"></dxi-column>
            <dxi-column dataField="orderLine.order.dealer.companyName" caption="Dealer" width="200"></dxi-column>
            <dxi-column dataField="orderLine.order.invoiceNumber" caption="Sales Order #" width="100"></dxi-column>
            <dxi-column dataField="orderLine.partNumber" caption="Part #" width="350"></dxi-column>
            <dxi-column dataField="quantity" width="75"></dxi-column>
            <dxi-column dataField="status.name" caption="Status" width="200"></dxi-column>
            <dxi-column dataField="isOption" width="100"></dxi-column>
            <dxi-column dataField="isReplacement" width="110"></dxi-column>
            <dxi-column dataField="isMisc" width="100"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-selection [mode]="'multiple'"></dxo-selection>
            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="built-log-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button type="button" class="btn btn-success" (click)="updateInventory(dataGrid.instance.getSelectedRowsData())">Update Inventory</button>
                <button type="button" class="btn btn-success ms-2" (click)="doNotUpdateInventory(dataGrid.instance.getSelectedRowsData())">Don't Update Inventory</button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="orderLineDetails" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
